export const CONTROLBAR_SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
} as const;

export const CONTROLBAR_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  FLAT: 'flat',
  GHOST: 'ghost',
} as const;
